import { getCurrentScope } from '@vue/composition-api';

const useStore = () => getCurrentScope().vm.$root.$store;

export default useStore;
